<form #f="ngForm"
  (ngSubmit)="(!f.form.valid ? onValidateGeneralInfo() : 'true') && f.form.valid  &&  onSubmit($event)" #pannelForm
  appFocusFirstElement class="w-100">
  <mat-accordion #accordion="matAccordion" [multi]="true">
    <!-- Section: Thông tin liên hệ -->
    <mat-expansion-panel *ngIf="check == 1" expanded="true" class="mat-elevation-z0" #mePanel="matExpansionPanel">
      <mat-expansion-panel-header>
        <!-- Thông tin liên hệ -->
        <mat-panel-title class="mat-panel-title justify-content-between">
          <span>{{'title.document_info' | translate}}</span>
          <small class="form-text text-gray pull-left">(<span style="color: red;">*</span>) {{'form.info' |
            translate}}
          </small>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row">
        <!-- Select option to choose between creating document by template or uploading -->
        <!-- Tên mẫu hợp đồng nếu có-->

        <!-- Fill service type when selected document type parent in add document upload or selected document type in add document form -->
        <!-- Loại HĐ -->
        <div class="col-4">
          <mat-form-field class="w-100" [class.input-document]="isShowAddDocument" [class.input-document-no]="!isShowAddDocument">
            <mat-label>{{'headertable.document_type' | translate}}
            </mat-label>
            <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)"
                        (selectionChange)="selectedChange($event)"
                        (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceTypeId"
                        name="serviceTypeId" [(ngModel)]="document.serviceType" #serviceTypeId="ngModel" required
                        [disabled]=" valueSelect === 0 || warningContractQuantity">
              <!-- [disabled]="selectedDocumentTypeParent && selectedDocumentTypeParent.id && valueSelect == 1 || selectedDocumentType && selectedDocumentType.id && valueSelect == 0"> -->
              <mat-option>
                <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                       [placeholderLabel]="'search_form.search' | translate"
                                       [formControl]="serviceTypesFilterCtrl">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                          (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                {{serviceType.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted || serviceTypeId.invalid || serviceTypeId.errors?.required">
              {{'validation.service_type' | translate}}
            </mat-error>
          </mat-form-field>
          <!--            Dấu + bên dưới-->
          <!-- <ng-container *ngIf="isShowAddDocument">
            <mat-icon
              matSuffix
              matTooltip="{{'enterprise_contract.panel_document.help_document_name.tooltip' | translate}}"
              class="custom-position-for-icon"
              style="cursor: pointer;"
              (click) = "openDialogAdd()"
            >add_circle_outline
            </mat-icon>
          </ng-container> -->

        </div>
        <div class="col-4">
          <!-- Tên HĐ -->
          <mat-form-field class="w-100" style="width: -webkit-calc(100% - 35px) !important;
                                              width: -moz-calc(100% - 35px) !important;
                                              width: calc(100% - 35px) !important;">
            <input (focusout)="document.name = document.name.trim()" matInput
                   placeholder="{{'form.doc_name' | translate}}" autocomplete="off" type="text" name="documentName"
                   #documentName="ngModel" [(ngModel)]="document.name" required
                   [ngClass]="{ 'is-invalid': f.submitted || documentName.invalid }" maxlength="100"
                   [disabled]="warningContractQuantity"/>
            <button mat-button *ngIf="document.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="document.name=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="f.submitted || documentName.invalid">
                      <span *ngIf="documentName?.errors?.required" class="text-error">
                        {{'validation.document_type_name' | translate}}
                      </span>
            </mat-error>
          </mat-form-field>
          <mat-icon matSuffix
                    matTooltip="{{'enterprise_contract.panel_document.help_document_name.tooltip' | translate}}"
                    class="custom-position-for-icon"
                    (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">help_outline
          </mat-icon>
          <ng-template #tplHelpTitle>
            <span>{{'enterprise_contract.panel_document.help_document_name.modal_title' | translate}}</span>
          </ng-template>
          <ng-template #tplHelpContent>
            <p>{{'enterprise_contract.panel_document.help_document_name.modal_content1' | translate}}</p>
            <p>{{'enterprise_contract.panel_document.help_document_name.modal_content2' | translate}}
              <b>{{'enterprise_contract.panel_document.help_document_name.modal_content3' | translate}}</b>
              {{'enterprise_contract.panel_document.help_document_name.modal_content4' | translate}}
            </p>
          </ng-template>
          <ng-template #tplHelpFooter>
            <button nz-button nzType="primary" (click)="destroyTplModal()">
              {{'button.close' | translate}}
            </button>
          </ng-template>
        </div>
        <div class="col-4">
          <!-- Mã HĐ -->
          <mat-form-field class="w-100">
            <input (focusout)="document.code = document.code.trim()" matInput
                   placeholder="{{'form.doc_code' | translate}}" autocomplete="off" type="text" name="code"
                   #code="ngModel" [(ngModel)]="document.code" [pattern]="documentCodePattern"
                   [ngClass]="{ 'is-invalid': f.submitted || code.invalid }" required maxlength="50" id="code"
                   [disabled]="warningContractQuantity || isOnAutoNumber"/>
            <button mat-button *ngIf="document.code && !isOnAutoNumber" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="document.code=''">
              <mat-icon>close</mat-icon>
            </button>
            <button mat-button *ngIf=" isOnAutoNumber && !refreshContractCode && isUpdate" type="button" matSuffix mat-icon-button
                    (click)="onRefreshContractCode()">
              <mat-icon  matTooltip="{{'enterprise_contract.tooltips.refresh' | translate}}" class="text-primary">refresh</mat-icon>
            </button>
            <mat-error *ngIf="(f.submitted || code.invalid) && !isOnAutoNumber">
                      <span *ngIf="code?.errors?.required" class="text-error">
                        {{'validation.document_type_code' | translate}}
                      </span>
              <span *ngIf="code?.errors?.pattern" class="text-error">
                        {{'validation.lbl_validation_document_code_format' | translate}}
                      </span>
              <span class="text-error" *ngIf="code?.errors?.duplicate">
                        {{'validation.document_code_duplicate' | translate}}
                      </span>
            </mat-error>
          </mat-form-field>
          <div *ngIf="isOnAutoNumber" class="w-100 pb-2" style="font-style: italic; transform: translateY(-10px) !important;">
            <span><strong>{{'service_type.remind_configuration.note' | translate}}</strong>
              <span *ngIf="isUpdate && refreshContractCode == false">{{'validation.note_contracts_documents_auto_update' | translate}}&nbsp;</span>
              <span *ngIf="!isUpdate">{{'validation.note_contracts_documents_auto' | translate}}&nbsp;</span>
              <span *ngIf="refreshContractCode == true">{{'validation.lbl_validation_refresh' | translate}}&nbsp;</span>
              <!-- {{'validation.error_user_confirm_bct_note_after' | translate}} -->
            </span>
          </div>
        </div>

        <div class="col-4">
          <!-- Loại hợp đồng lao động -->
          <mat-form-field class="w-100">
            <mat-label>{{'form.digital_contract.labor_contract_type' | translate}}</mat-label>
            <input matInput [(ngModel)]="document.laborContractType" [ngModelOptions]="{standalone: true}" disabled>
          </mat-form-field>
        </div>

        <!-- Thời gian lập (từ ngày) -->
        <!-- Hợp đồng xác định thời hạn thì bắt buộc -->
        <div class="col-4">
          <mat-form-field class="w-100">
            <mat-label>{{ 'form.effective_date' | translate }}</mat-label>
            <input
              matInput 
              [matDatepicker]="effectiveDate" 
              [max]="document.expiredDate"
              #effectiveDateCtrl="ngModel"
              (change)="this.commonService.resetDatePicker(pickerInputEffective.value, this.ngForm.controls['effectiveDate'])"
              name="effectiveDate" 
              #pickerInputEffective 
              [(ngModel)]="document.effectiveDate" maxlength="200"
              (focus)="effectiveDateErr = 'effectiveDate'" 
              autocomplete="off"
              required
              />
            <mat-datepicker-toggle matSuffix [for]="effectiveDate">
              <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                 [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
            </mat-datepicker-toggle>
            <mat-datepicker #effectiveDate></mat-datepicker>
            <mat-error *ngIf="effectiveDateCtrl.invalid">
              <span class="text-error" *ngIf="effectiveDateCtrl.invalid">
                  {{getErrorDateMessageV2(pickerInputEffective.value, true, 'effectiveDate')}}
              </span>
              <span class="text-error" *ngIf="getErrorDateMessageV2(pickerInputEffective.value, false, 'effectiveDate')==null">
                {{'validation.effective_date' | translate}}
              </span>
            </mat-error>
            <!-- <mat-error *ngIf="effectiveDateCtrl?.errors?.matDatepickerMax && effectiveDateErr == 'effectiveDate' && !getErrorDateMessageV2(pickerInputEffective.value)">
              {{ 'form.effective_date' | translate }}
              {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
              {{ 'form.expired_date' | translate }}
            </mat-error> -->
          </mat-form-field>
        </div>

        <!-- Hợp đồng xác định thời hạn thì bắt buộc -->
        <div class="col-4" *ngIf="document.employmentContractTerm == 'LIMITED'">
          <!-- Ngày hết hiệu lực -->
          <mat-form-field class="w-100" [class.mb-3]="valueSelect != 1">
            <mat-label>{{'form.expired_date' | translate}}</mat-label>
            <input matInput [matDatepicker]="expiredDate1" [min]="document.effectiveDate" maxlength="10" [ngClass]="{ 'is-invalid': expiredDateCtrl.invalid }"
              name="expiredDate" 
              #pickerInputExpired 
              (change)="this.commonService.resetDatePicker(pickerInputExpired.value, this.ngForm.controls['expiredDate'])"
              [(ngModel)]="document.expiredDate" 
              #expiredDateCtrl="ngModel"
              (focus)="effectiveDateErr = 'expiredDate'"
              (keyup)="expiredDateChange(pickerInputExpired.value)" 
              [disabled]="warningContractQuantity"
              required
            />
            <mat-datepicker-toggle matSuffix [for]="expiredDate1">
              <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                 [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
            </mat-datepicker-toggle>
            <mat-datepicker #expiredDate1></mat-datepicker>
            <mat-error *ngIf="expiredDateCtrl.invalid">
              <span class="text-error" *ngIf="expiredDateCtrl.invalid">
                  {{getErrorDateMessageV2(pickerInputExpired.value, false, 'expiredDate')}}
              </span>
              <span class="text-error" *ngIf="getErrorDateMessageV2(pickerInputExpired.value, false, 'expiredDate')==null">
                {{'validation.expired_date' | translate}}
              </span>
            </mat-error>
            <!-- <mat-error *ngIf="expiredDateCtrl?.errors?.required" class="text-error">
              {{'validation.expired_date' | translate}}
            </mat-error>
            <mat-error *ngIf="expiredDateCtrl?.errors?.matDatepickerParse">
              {{'validation.format_of_date' | translate}}
            </mat-error>
            <mat-error *ngIf="expiredDateCtrl?.errors?.matDatepickerMin && effectiveDateErr == 'expiredDate'">
              {{ 'form.expired_date' | translate }}
              {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
              {{ 'form.effective_date' | translate }}
            </mat-error> -->
          </mat-form-field>
        </div>

        <div class="col-4" *ngIf="document.employmentContractTerm != 'LIMITED'">
          <!-- Ngày hết hiệu lực -->
          <mat-form-field class="w-100" [class.mb-3]="valueSelect != 1">
            <mat-label>{{'form.expired_date' | translate}}</mat-label>
            <input matInput [matDatepicker]="expiredDate1" [min]="document.effectiveDate" maxlength="10" [ngClass]="{ 'is-invalid': expiredDateCtrl.invalid }"
              name="expiredDate" 
              #pickerInputExpired 
              (change)="this.commonService.resetDatePicker(pickerInputExpired.value, this.ngForm.controls['expiredDate'])"
              [(ngModel)]="document.expiredDate" 
              #expiredDateCtrl="ngModel"
              (focus)="effectiveDateErr = 'expiredDate'"
              (keyup)="expiredDateChange(pickerInputExpired.value)" 
              [disabled]="warningContractQuantity"/>
            <mat-datepicker-toggle matSuffix [for]="expiredDate1">
              <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                 [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
            </mat-datepicker-toggle>
            <mat-datepicker #expiredDate1></mat-datepicker>
            <mat-error *ngIf="expiredDateCtrl.invalid">
              <span class="text-error" *ngIf="expiredDateCtrl.invalid">
                  {{getErrorDateMessageV2(pickerInputExpired.value, false, 'expiredDate')}}
              </span>
              <span class="text-error" *ngIf="getErrorDateMessageV2(pickerInputExpired.value, false, 'expiredDate')==null">
                {{'validation.expired_date' | translate}}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-4" *ngIf="valueSelect === 0">
          <mat-form-field class="w-100">
            <mat-label>{{'form.doc_type' | translate}}</mat-label>
            <input matInput [(ngModel)]="selectedDocumentType.name" [ngModelOptions]="{standalone: true}"
                   disabled>
          </mat-form-field>
        </div>

        <!-- Nội dung điều chỉnh  -->
        <div class="col-4" *ngIf="isPlContract">
          <mat-form-field class="w-100">
            <mat-label>{{'add_document_moha.edit_content' | translate}}
            </mat-label>
            <mat-select #adjustedSelect (focusout)="(checkFocus = true)"
                        (selectionChange)="selectedAdjustChange($event)"
                        (focus)="commonService.openComboBox(checkFocus, adjustedSelect)" id="editProperty"
                        name="editProperty" [(ngModel)]="document.editProperty" #editProperty="ngModel" required
            >
              <!-- <mat-option>
                <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                       [placeholderLabel]="'search_form.search' | translate"
                                       [formControl]="serviceTypesFilterCtrl">
                </ngx-mat-select-search>
              </mat-option> -->
              <mat-option *ngFor="let adjusted of adjustedContents" [value]="adjusted.type"
                          (click)="this.commonService.closeDropdownList(this.adjustedSelect)">
                {{adjusted.title}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted || editProperty.invalid || editProperty.errors?.required">
              {{'add_document_moha.validation.required_content' | translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div [class]="valueSelect === 0 ? 'col-8' : (isPlContract ? 'col-8' : 'col-12')">
          <mat-form-field class="w-100" style="position: relative;">
            <textarea cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2" style="padding-right: 30px; min-height: 28px !important; height: 28px;" (focusout)="document.summary = document.summary.trim()" rows="1" matInput
              [placeholder]="'form.contract_summary' | translate" rows="1" type="text" name="summary" id="summary"
              [(ngModel)]="document.summary" maxlength="500" spellcheck="false"></textarea>
              <button style="position: absolute; top: 5px; right: 14px;" mat-button *ngIf="document.summary" type="button" mat-icon-button aria-label="Clear"
                    (click)="document.summary=''">
                <mat-icon style="font-size: 16px;">close</mat-icon>
              </button>
          </mat-form-field>
        </div>
      </div>

    </mat-expansion-panel>

    <div class="row" *ngIf="check == 2">
      <div class="w-50">
        <!-- Hợp đồng văn bản liên kết -->
        <mat-expansion-panel class="mat-elevation-z0" *ngIf="document.formType != 'CONTRACT_TERMINATION' || (contractTerminations.length > 0 && document.formType != 'CONTRACT_TERMINATION' && flagCopy)">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'form.digital_contract.document_parent' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-accordion #accordion="matAccordion" [multi]="true">
            <div class="" >
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowInternalTable nzBordered [nzData]="dataDocumentParent" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="60%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell d-flex align-items-center">
                          <div style="margin-right: 12px;">
                            <svg *ngIf="data.isContractShare" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.breadcrumb' | translate}}">
                              <path d="M9 8.54C8.62 8.54 8.28 8.69 8.02 8.925L4.455 6.85C4.48 6.735 4.5 6.62 4.5 6.5C4.5 6.38 4.48 6.265 4.455 6.15L7.98 4.095C8.25 4.345 8.605 4.5 9 4.5C9.83 4.5 10.5 3.83 10.5 3C10.5 2.17 9.83 1.5 9 1.5C8.17 1.5 7.5 2.17 7.5 3C7.5 3.12 7.52 3.235 7.545 3.35L4.02 5.405C3.75 5.155 3.395 5 3 5C2.17 5 1.5 5.67 1.5 6.5C1.5 7.33 2.17 8 3 8C3.395 8 3.75 7.845 4.02 7.595L7.58 9.675C7.555 9.78 7.54 9.89 7.54 10C7.54 10.805 8.195 11.46 9 11.46C9.805 11.46 10.46 10.805 10.46 10C10.46 9.195 9.805 8.54 9 8.54Z" fill="black"/>
                            </svg>
                            <svg *ngIf="!data.isContractShare" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.internal_contract' | translate}}">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.99894 0.5H9.95711L12 2.54289V12.5H8.5V11.5H11V4H8.5V1.5H2.99894V4H1.99894V0.5ZM9.5 1.5V3H11V2.95711L9.54289 1.5H9.5ZM4.5 6C3.94772 6 3.5 6.44772 3.5 7V7.5H5.5V7C5.5 6.44772 5.05228 6 4.5 6ZM6.5 7.5V7C6.5 5.89543 5.60457 5 4.5 5C3.39543 5 2.5 5.89543 2.5 7V7.5H1.5V12.5H7.5V7.5H6.5ZM6.5 8.5H2.5V11.5H6.5V8.5ZM5 9.5V10.5H4V9.5H5Z" fill="black"/>
                            </svg>
                          </div>
                          <div class="row-icon" style="flex: 1;" [ngStyle]="{ 'text-decoration': data.isRevokeContractShare ? 'line-through' : 'none'}"> {{ data.code }}
                            - {{ data.name }}
                          </div>
                          <div *ngIf="data.isRevokeContractShare" style="height: 20px;">
                            <svg matTooltip="{{ 'contract_share_partner.revoked_tooltip' | translate }}" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.125 6.3125C1.125 3.72391 3.22391 1.625 5.8125 1.625C8.40109 1.625 10.5 3.72391 10.5 6.3125C10.5 8.90109 8.40109 11 5.8125 11C3.22391 11 1.125 8.90109 1.125 6.3125ZM5.8125 2.375C3.63812 2.375 1.875 4.13812 1.875 6.3125C1.875 8.48688 3.63812 10.25 5.8125 10.25C7.98688 10.25 9.75 8.48688 9.75 6.3125C9.75 4.13812 7.98688 2.375 5.8125 2.375Z" fill="#CD002A"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.78125 5.65625C4.78125 5.44914 4.94914 5.28125 5.15625 5.28125H5.90625C6.11336 5.28125 6.28125 5.44914 6.28125 5.65625V8.375C6.28125 8.58211 6.11336 8.75 5.90625 8.75C5.69914 8.75 5.53125 8.58211 5.53125 8.375V6.03125H5.15625C4.94914 6.03125 4.78125 5.86336 4.78125 5.65625Z" fill="#CD002A"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 8.46875C4.5 8.26164 4.66789 8.09375 4.875 8.09375H6.9375C7.14461 8.09375 7.3125 8.26164 7.3125 8.46875C7.3125 8.67586 7.14461 8.84375 6.9375 8.84375H4.875C4.66789 8.84375 4.5 8.67586 4.5 8.46875Z" fill="#CD002A"/>
                              <path d="M5.8125 3.54688C5.69198 3.54688 5.57416 3.58261 5.47395 3.64957C5.37374 3.71653 5.29563 3.8117 5.24951 3.92305C5.20339 4.0344 5.19132 4.15693 5.21483 4.27513C5.23835 4.39334 5.29638 4.50192 5.38161 4.58714C5.46683 4.67237 5.57541 4.7304 5.69362 4.75392C5.81182 4.77743 5.93435 4.76536 6.0457 4.71924C6.15705 4.67312 6.25222 4.59501 6.31918 4.4948C6.38614 4.39459 6.42188 4.27677 6.42188 4.15625C6.42188 3.99463 6.35767 3.83964 6.24339 3.72536C6.12911 3.61108 5.97412 3.54688 5.8125 3.54688Z" fill="#CD002A"/>
                            </svg>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
                        <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
                        <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
                        <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
                        <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                        <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
                        <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
                        <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
                        <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)" *ngIf="!data.isRevokeContractShare; else noPermission"  aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                        <button (click)="onClickDeleteElementRecordInternalUser(data.id)"
                                *ngIf="data.id " aria-label="Clear"
                                mat-button mat-icon-button matSuffix style="color: #ee0033"
                                type="button">
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </button>
                        <ng-template #noPermission>
                          <button mat-icon-button disabled>
                            <span> </span>
                          </button>
                        </ng-template>
                      </td>
                    </tr>
                    <tr class="editable-row">
                      <!-- TT -->
                      <td class="text-center">&nbsp;</td>
                      <!-- Tên -->
                      <td colspan="3">
                        <div>
                          <nz-input-group [nzSuffix]="suffixPartyInput">
                            <input nz-input [(ngModel)]="inputInternalDocumentsValue" (input)="getParentContractNew($event)"
                                   [nzAutocomplete]="autoInternalUserSearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.document_parent' | translate
                      }}" #autocompleteInput id="inputUser1" />
                            <nz-autocomplete #autoInternalUserSearching>
                              <nz-auto-option *ngFor="let user of parentContracts"
                                              (selectionChange)="autocompleteInternalUserSelected($event, user)"
                                              [nzValue]="''">
                                <div class="d-flex">
                                  <span style="line-height: 20px">
                                      {{ user.code }} - {{ user.name }}
                                    </span>
                                </div>
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixPartyInput>
                            <nz-spin *ngIf="nzCheckLoadingParty1" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                               style="font-size: 24px"></i>
                          </ng-template>
                        </div>
                      </td>
                      <!-- Thực hiện -->
                      <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable1 ></ng-template>
                </form>
              </div>
            </div>
          </mat-accordion>
        </mat-expansion-panel>
        <!-- Hợp đồng lao động gốc  -->
        <mat-expansion-panel class="mat-elevation-z0" *ngIf="isPlContract">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'add_document_moha.original_employment_contract' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-accordion #accordion="matAccordion" [multi]="true">
            <div class="" >
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowEditTable nzBordered [nzData]="document.dataOriginalContract" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable3"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="75%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowEditTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell d-flex align-items-center">
                          <div class="row-icon" style="text-decoration: underline; color: #4e73df; cursor: pointer;" (click)="goToContractLiquidated(data.id)"> {{ data.code }}
                            - {{ data.name }}
                          </div>
                        </div>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)"  aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable3 ></ng-template>
                </form>
              </div>
            </div>
          </mat-accordion>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" *ngIf="document.formType == 'CONTRACT_TERMINATION' || (contractTerminations.length > 0 && document.formType != 'CONTRACT_TERMINATION' && !flagCopy)">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'contract_terminate.contract_liquidated' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-accordion #accordion="matAccordion" [multi]="true">
            <div class="" >
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #contractTerminationsTable nzBordered [nzData]="contractTerminations" [nzShowPagination]="false"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="75%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of contractTerminationsTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell d-flex align-items-center">
                          <div class="row-icon"> 
                            <span style="color: blue; text-decoration: underline; cursor: pointer;" role="button"  (click)="goToContractLiquidated(data.id)" target="_parent">{{ data.code }} - {{ data.name }}</span>
                          </div>
                        </div>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)" aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </form>
              </div>
            </div>
          </mat-accordion>
        </mat-expansion-panel>
      </div>
      <div class="w-50">
        <div class="col-12">
          <app-record-party-sign-moha [check]="2"></app-record-party-sign-moha>
        </div>
        <div class="col-12">
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title">
                {{'contract_share_partner.share_contracts_with_partners' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-accordion #accordion="matAccordion" [multi]="true">
              <div class="" >
                <div class="w-100 ">
                  <form nz-frm>
                    <nz-table #editRowSharePartnerTable nzBordered [nzData]="RECORD_SHARE_PARTNER" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                              [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                      <thead>
                      <tr>
                        <th class="text-center" nzWidth="25px">
                          {{
                            "view_document_information.table_headers.signingApostropheContractUnit.no"
                              | translate
                          }}
                        </th>
                        <th class="text-center" nzWidth="65%">
                          {{
                            "view_document_information.table_headers.signingApostropheContractUnit.member"
                              | translate
                          }}
                        </th>
                        <th class="text-center" nzWidth="150px">
                          {{ 'contract_share_partner.view_permission' | translate }}
                        </th>
                        <th class="text-center"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let data of editRowSharePartnerTable.data; let i = index" class="editable-row">
                        <!-- TT -->
                        <td class="text-center">{{ i + 1 }}</td>
                        <!-- Tên -->
                        <td class="word-break-line">
                          <div class="editable-cell d-flex align-items-center">
                            <div style="margin-right: 12px;">
                              <svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.4001 3.60005C5.4001 4.07744 5.21046 4.53528 4.87289 4.87284C4.53532 5.21041 4.07749 5.40005 3.6001 5.40005C3.12271 5.40005 2.66487 5.21041 2.32731 4.87284C1.98974 4.53528 1.8001 4.07744 1.8001 3.60005C1.8001 3.12266 1.98974 2.66482 2.32731 2.32726C2.66487 1.98969 3.12271 1.80005 3.6001 1.80005C4.07749 1.80005 4.53532 1.98969 4.87289 2.32726C5.21046 2.66482 5.4001 3.12266 5.4001 3.60005ZM10.2001 3.60005C10.2001 3.83643 10.1535 4.07049 10.0631 4.28888C9.97262 4.50727 9.84004 4.7057 9.67289 4.87284C9.50574 5.03999 9.30731 5.17257 9.08893 5.26303C8.87054 5.35349 8.63648 5.40005 8.4001 5.40005C8.16372 5.40005 7.92965 5.35349 7.71127 5.26303C7.49288 5.17257 7.29445 5.03999 7.12731 4.87284C6.96016 4.7057 6.82757 4.50727 6.73711 4.28888C6.64666 4.07049 6.6001 3.83643 6.6001 3.60005C6.6001 3.12266 6.78974 2.66482 7.12731 2.32726C7.46487 1.98969 7.92271 1.80005 8.4001 1.80005C8.87749 1.80005 9.33533 1.98969 9.67289 2.32726C10.0105 2.66482 10.2001 3.12266 10.2001 3.60005ZM7.7581 10.2C7.7857 10.0038 7.8001 9.80405 7.8001 9.60005C7.80149 8.65736 7.48434 7.74186 6.9001 7.00205C7.35615 6.73875 7.87348 6.60013 8.40008 6.60013C8.92668 6.60012 9.44401 6.73873 9.90006 7.00203C10.3561 7.26533 10.7348 7.64403 10.9981 8.10008C11.2615 8.55612 11.4001 9.07345 11.4001 9.60005V10.2H7.7581ZM3.6001 6.60005C4.39575 6.60005 5.15881 6.91612 5.72142 7.47873C6.28403 8.04134 6.6001 8.8044 6.6001 9.60005V10.2H0.600098V9.60005C0.600098 8.8044 0.916168 8.04134 1.47878 7.47873C2.04139 6.91612 2.80445 6.60005 3.6001 6.60005Z" fill="black"/>
                              </svg>
                            </div>
                            <div class="row-icon"> {{ data.name }} <span *ngIf="data.email"> - {{ data.email }}</span><span *ngIf="data.phone"> - {{ data.phone }}</span></div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center justify-content-center cursor-pointer" [matMenuTriggerFor]="menuFeature">
                            <div >
                              <span *ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' | translate}}</span>
                              <span *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' | translate}}</span>
                            </div>
                            <div>
                              <button mat-icon-button><mat-icon>keyboard_arrow_down</mat-icon></button>
                              <mat-menu #menuFeature="matMenu">
                                <button mat-menu-item (click)="data.permission = 'FILE'"  [ngClass]="{'active': data.permission == 'FILE'}">
                                  {{'contract_share_partner.view_file_contract' | translate}}
                                </button>
                                <button mat-menu-item (click)="data.permission = 'FULL'"  [ngClass]="{'active': data.permission == 'FULL'}">
                                  {{'contract_share_partner.view_detail_contract' | translate}}
                                </button>
                              </mat-menu>
                            </div>
                          </div>
                        </td>
                        <!-- Action -->
                        <td class="td-nz-icon text-center">
                          <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                                  'contract_share_partner.confirm_delete_customer' | translate
                                }}" (nzOnConfirm)="onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)"
                            nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                            <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                          </a>
                          <ng-template #iconDel>
                            <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                          </ng-template>
                        </td>
                      </tr>
                      <tr class="editable-row">
                        <!-- TT -->
                        <td class="text-center">&nbsp;</td>
                        <!-- Tên -->
                        <td colspan="3">
                          <div>
                            <nz-input-group [nzSuffix]="suffixPartyInput2">
                              <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                                     [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                                      'contract_share_partner.enter_partner_customer' | translate
                                    }}" #focusPartyInput id="inputParty" />
                              <nz-autocomplete #autoPartySearching>
                                <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                                        autocompletePartySelected($event, party)
                                      " [nzValue]="''">
                                  <div class="d-flex">
                                    <mat-icon class="mr-2">account_circle</mat-icon>
                                    <span style="line-height: 20px">
                                        {{ party.name }} -
                                      {{
                                        party.taxCode && party.taxCode.length > 0
                                          ? party.taxCode
                                          : party.certificateNo
                                      }}
                                      </span>
                                  </div>
                                  <div class="d-flex">
                                    <mat-icon class="mr-2">contact_mail</mat-icon>
                                    <span style="line-height: 20px">
                                        <span *ngIf="party.email">{{ party.email }} -</span>
                                      {{ party.phone }}
                                      </span>
                                  </div>
                                  <hr style="margin: 0; padding: 0" />
                                </nz-auto-option>
                              </nz-autocomplete>
                            </nz-input-group>
                            <ng-template #suffixPartyInput2>
                              <nz-spin *ngIf="nzCheckLoadingParty2" nzSimple [nzIndicator]="indicatorPartyInput2"></nz-spin>
                            </ng-template>
                            <ng-template #indicatorPartyInput2><i class="nz-icon-font" nz-icon nzType="loading"
                                                                 style="font-size: 24px"></i>
                            </ng-template>
                          </div>
                        </td>
                        <!-- Thực hiện -->
                        <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                      </tr>
                      </tbody>
                    </nz-table>
                    <ng-template #contentEmptyTable1 ></ng-template>
                  </form>
                </div>
              </div>
            </mat-accordion>
          </mat-expansion-panel>
        </div>
      </div>

      <div class="col-12" style="padding-right: 2.75rem;">
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'form.attach_file_list' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-accordion #accordion="matAccordion" [multi]="true">
            <app-upload-multi-file-attachments-moha (hasChange)="onNewUploadChange($event)" [isAttachFileForDocument]="true"
                                   [arrAttachments]="this.document.newUploadContractAttachments"
                                   [typeCreateContract]="this.createContractMohaService.createContractType.getValue() ? this.createContractMohaService.createContractType.getValue() : document.typeId"
                                   [isEdit]="!!document.id"
                                   [isCopy]="flagCopy == 'true' ? true : false"
                                   [maxSize]="maxSize"
                                   [checkMan]="check == 2?true:false"
                                   [messageError]="messageError"
                                   (click)="onClickUpload()">
            </app-upload-multi-file-attachments-moha>
            <mat-error class="text-error" *ngIf="duplicatedUploadFileNames?.length > 0">
              <span>{{duplicatedUploadFileTitle}}</span>
              <ul>
                <li *ngFor="let err of duplicatedUploadFileNames">
                  {{err}}
                </li>
              </ul>
            </mat-error>
            <mat-hint class="hint-text d-flex justify-content-center">
              {{'hint.attach_accept_pdf_image_email' | translate}}
            </mat-hint>
          </mat-accordion>

          <!-- list contract attchments-->
          <!-- <div class="mt-2 fix-width" *ngFor="let item of document.contractAttachments">
            <ng-container *ngIf="item.id === null; else isFileSaved">
              <em class="fa fa-file fa-fw text-primary"></em>
              <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
            </ng-container>
            <ng-template #isFileSaved>
              <a (click)="downloadFile(item.id, item.fileName)">
                <em class="fa fa-download fa-fw text-primary" matTooltip="{{'tooltips.download' | translate}}"></em>
              </a>
              <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
            </ng-template>
          </div> -->
        </mat-expansion-panel>
      </div>
    </div>
    <!-- Liên kết đến HĐ cha (đã có) -->

    <!--Section: Danh sách tệp đính kèm -->

  </mat-accordion>
  <button type="submit" (click)="onSubmit($event)" #panelSubmit style="display: none;"></button>
</form>
